<template>
  <!--
      	作者：gmshop
      	时间：2019-06-04
      	描述：插件中心-分销-分销设置-基础设置
      -->
  <div class="product-add mt30">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <el-form-item label="是否开启分销功能">
        <div>
          <el-radio v-model="form.is_open" label="1">开启</el-radio>
          <el-radio v-model="form.is_open" label="0">关闭</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="是否开启返利支付返利">
        <div>
          <el-radio v-model="form.open_balance_pay_commission" label="1">开启</el-radio>
          <el-radio v-model="form.open_balance_pay_commission" label="0">关闭</el-radio>
          <div class="tips">如关闭，使用返利支付将不产生返利</div>
        </div>
      </el-form-item>
      <el-form-item label="是否开启会员折扣差返利"  v-auth="'/plus/agent/discount/price'">
        <div>
          <el-radio v-model="form.is_open_discount" label="1">开启</el-radio>
          <el-radio v-model="form.is_open_discount" label="0">关闭</el-radio>
          <div class="tips">如开启，会员级别大于等于 1 的等级生效</div>
        </div>
      </el-form-item>
      <el-form-item label="是否开启代理返利" v-auth="'/plus/agent/discount/index'">
        <div>
          <el-radio v-model="form.is_open_agency_discount" label="0">关闭</el-radio>
          <el-radio v-model="form.is_open_agency_discount" label="1">按照级差返</el-radio>
          <el-radio v-model="form.is_open_agency_discount" label="2">无级差</el-radio>
          <div class="tips">如开启，会员级别大于等于 1 的等级生效，无级差：根据实际奖励金额返利;按照级差返：同时存在高低等级的情况下，高等级的奖励需要先扣除低等级的奖励</div>
        </div>
      </el-form-item>
      <el-form-item label="是否开启分销返积分：" v-auth="'/plus/agent/point'">
         <el-radio-group v-model="form.is_open_agent_point" >
           <el-radio label="1">开启</el-radio>
           <el-radio label="0">关闭</el-radio>
         </el-radio-group>
      </el-form-item>
      <el-form-item label="分销层级">
        <div>
          <el-radio v-model="form.level" label="1">一级分销</el-radio>
          <el-radio v-model="form.level" label="2">二级分销</el-radio>
          <el-radio v-model="form.level" label="3">三级分销</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="分销商内购">
        <div>
          <el-radio v-model="form.self_buy" label="1">开启</el-radio>
          <el-radio v-model="form.self_buy" label="0">关闭</el-radio>
          <div class="tips">如开启，分销商自己购买商品，获得一级佣金</div>
        </div>
      </el-form-item>
      <el-form-item label="开启2+1归属模式" v-auth="'/plus/agent/belongmode'">
        <div>
          <el-radio v-model="form.open_belong_status" label="0">否</el-radio>
          <el-radio v-model="form.open_belong_status" label="10">是</el-radio>
           <div class="tips">开启后级别大于1的用户可获得直推推用户的前两个归属权益，设定后不可撤销</div>
        </div>
      </el-form-item>
      <div  v-auth="'/user/user/editAgent'">
          <div  class="common-form">2+1链动模式参数</div>
          <el-form-item label="开启模式">
            <div>
              <el-radio v-model="form.open_plus" label="1">开启</el-radio>
              <el-radio v-model="form.open_plus" label="0">关闭</el-radio>
              <div class="tips"></div>
            </div>
          </el-form-item>
          <el-form-item label="收益转帮扶基金比例 ">
            <el-input v-model="form.boss_agent_wait" type="number" min="0" max="100" class="max-w460"></el-input>
            <span class="ml10">%</span>
            <div class="tips">累计收益达到最大解冻额度限额是 可解冻到可提现</div>
          </el-form-item>
          <el-form-item label="收益复购佣金比例 ">
            <el-input v-model="form.boss_agent_balance_rate" type="number" min="0" max="100" class="max-w460"></el-input>
            <span class="ml10">%</span>
            <div class="tips">佣金支付时可使用该部分收益</div>
          </el-form-item>
          <el-form-item label="收益转手续费比例 ">
            <el-input v-model="form.boss_agent_rate" type="number" min="0" max="100" class="max-w460"></el-input>
            <span class="ml10">%</span>
          </el-form-item>
          <el-form-item label="收益解冻额度 ">
            <el-input v-model="form.boss_agent_limit" type="number" min="0" class="max-w460"></el-input>
            <span class="ml10">元</span>
            <div class="tips">2+1链动代理老板模式获得的推荐收益</div>
          </el-form-item>
          <!-- <el-form-item label="代理层级返利层数 ">
            <el-input v-model="form.boss_agent_level" type="number" min="0" class="max-w460"></el-input>
            <span class="ml10">层</span>
            <div class="tips">直推N个代理可享受往下N代的 代理返利,举例：填写10 则表示最多返10层</div>
          </el-form-item> -->
      </div>
      

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        is_open: '',
        open_plus: '0',
        is_open_discount: '0',
        is_open_agent_point: '0',
        open_balance_pay_commission: '1',
        is_open_agency_discount: '0',
        level: '',
        self_buy: ''
      },
      /*是否正在加载*/
      loading: false
    };
  },
  props:{
    settingData:Object
  },
  created() {

    this.form=this.settingData.data.basic.values;
  },
  methods: {

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      PlusApi.basic(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });

        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/agent/setting/part/Basic.vue